import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fw-bold mb-1" };
const _hoisted_2 = { class: "mb-3 text-secondary" };
const _hoisted_3 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_4 = { class: "row mb-4" };
const _hoisted_5 = { class: "col-lg-6 col-12" };
const _hoisted_6 = { class: "form-check mb-3" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = { class: "mb-3" };
const _hoisted_11 = { class: "mb-3" };
const _hoisted_12 = { class: "col-lg-6 col-12" };
const _hoisted_13 = { class: "d-flex justify-content-end" };
const _hoisted_14 = ["href"];
const _hoisted_15 = {
    key: 0,
    class: "d-flex flex-wrap"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "currentColor",
    class: "bi bi-x-circle text-muted",
    viewBox: "0 0 16 16"
};
const _hoisted_18 = {
    class: "modal fade",
    id: "createDeliveryTypeCountry",
    tabindex: "-1",
    "aria-labelledby": "createDeliveryTypeCountryModalLabel",
    "aria-hidden": "true"
};
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_20 = { class: "modal-content" };
const _hoisted_21 = { class: "modal-body" };
const _hoisted_22 = { class: "form-floating mb-3" };
const _hoisted_23 = ["value"];
import { FilterMatchMode } from '@primevue/core/api';
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { Column, DataTable, useConfirm } from 'primevue';
import TinyEditor from '@/Components/TinyEditor.vue';
import YesNoIcon from '@/Shared/YesNoIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        deliveryType: {
            type: Object,
            required: true
        },
        countries: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const confirm = useConfirm();
        const editDeliveryTypeForm = useForm({
            name: props.deliveryType?.name ?? '',
            nameEn: props.deliveryType?.nameEn ?? '',
            description: props.deliveryType?.description ?? '',
            descriptionEn: props.deliveryType?.descriptionEn ?? '',
            deliveryTime: props.deliveryType?.deliveryTime ?? null,
            active: props.deliveryType?.active ?? false
        });
        const createDeliveryTypeCountryForm = useForm({
            countryId: null
        });
        function updateDeliveryType() {
            editDeliveryTypeForm.transform((data) => ({
                name: data.name,
                name_en: data.nameEn,
                description: data.description,
                description_en: data.descriptionEn,
                delivery_time: data.deliveryTime,
                active: data.active
            }))
                .submit('put', route('admin.deliveryTypes.update', props.deliveryType.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeDeliveryType() {
            confirm.require({
                message: 'Soll die Versandart wirklich gelöscht werden?',
                header: 'Versandart löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.deliveryTypes.destroy', props.deliveryType.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        function createDeliveryTypeCountry() {
            createDeliveryTypeCountryForm.transform((data) => ({
                country_id: data.countryId
            })).submit('post', route('admin.deliveryTypes.countries.store', props.deliveryType.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    createDeliveryTypeCountryForm.reset();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function removeDeliveryTypeCountry(uuid) {
            confirm.require({
                message: 'Soll die Länderoption wirklich gelöscht werden?',
                header: 'Länderoption löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.deliveryTypes.countries.destroy', uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Versandart" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Versandart: " + _toDisplayString(props.deliveryType.name), 1),
                        _createElementVNode("p", _hoisted_2, "Letzte Änderung: " + _toDisplayString(_unref(formatDate)(props.deliveryType.updatedAt, true)), 1),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(updateDeliveryType, ["prevent"])
                                    }, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "active",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editDeliveryTypeForm).active) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editDeliveryTypeForm).active]
                                            ]),
                                            _cache[9] || (_cache[9] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "active"
                                            }, "Aktiv (Versandart kann genutzt werden)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editDeliveryTypeForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editDeliveryTypeForm).name]
                                            ]),
                                            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "nameEn",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editDeliveryTypeForm).nameEn) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editDeliveryTypeForm).nameEn]
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control",
                                                id: "deliveryTime",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editDeliveryTypeForm).deliveryTime) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editDeliveryTypeForm).deliveryTime]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "deliveryTime" }, "Lieferzeit in Tagen", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _cache[13] || (_cache[13] = _createElementVNode("label", {
                                                for: "description",
                                                class: "mb-2"
                                            }, "Beschreibung", -1)),
                                            _createVNode(TinyEditor, {
                                                id: "description",
                                                modelValue: _unref(editDeliveryTypeForm).description,
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editDeliveryTypeForm).description) = $event)),
                                                height: 300
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _cache[14] || (_cache[14] = _createElementVNode("label", {
                                                for: "descriptionEn",
                                                class: "mb-2"
                                            }, "Beschreibung (en)", -1)),
                                            _createVNode(TinyEditor, {
                                                id: "descriptionEn",
                                                modelValue: _unref(editDeliveryTypeForm).descriptionEn,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editDeliveryTypeForm).descriptionEn) = $event)),
                                                height: 300
                                            }, null, 8, ["modelValue"])
                                        ]),
                                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    (props.deliveryType.canRemove)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                            onClick: removeDeliveryType
                                        }, [...(_cache[16] || (_cache[16] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-x-circle",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                ], -1),
                                                _createElementVNode("span", { class: "ms-2" }, "Versandart löschen", -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[21] || (_cache[21] = _createElementVNode("button", {
                                        class: "btn btn-secondary d-inline-flex align-items-center",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#createDeliveryTypeCountry"
                                    }, [
                                        _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-plus-lg",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", {
                                                "fill-rule": "evenodd",
                                                d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                            })
                                        ]),
                                        _createElementVNode("span", { class: "ms-2" }, "Neue Länderoption")
                                    ], -1)),
                                    _createVNode(_unref(DataTable), {
                                        dataKey: "id",
                                        value: props.deliveryType.deliveryTypeCountries,
                                        stripedRows: "",
                                        responsiveLayout: "scroll",
                                        globalFilterFields: ['name'],
                                        filters: tableFilter.value,
                                        "onUpdate:filters": _cache[7] || (_cache[7] = ($event) => ((tableFilter).value = $event)),
                                        paginator: true,
                                        rows: 10,
                                        paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                        rowsPerPageOptions: [10, 25, 50, 150],
                                        currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                                    }, {
                                        header: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                                    placeholder: "Suche",
                                                    style: { "width": "250px" }
                                                }, null, 512), [
                                                    [_vModelText, tableFilter.value['global'].value]
                                                ])
                                            ])
                                        ]),
                                        empty: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                            ]))]),
                                        loading: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                                _createTextVNode(" Einträge werden geladen ... ", -1)
                                            ]))]),
                                        default: _withCtx(() => [
                                            _createVNode(_unref(Column), {
                                                header: "#",
                                                sortable: true
                                            }, {
                                                body: _withCtx((slotProps) => [
                                                    _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(Column), {
                                                header: "Land",
                                                sortable: true,
                                                sortField: "name"
                                            }, {
                                                body: _withCtx((slotProps) => [
                                                    _createElementVNode("a", {
                                                        href: _ctx.route('admin.deliveryTypes.countries.edit', slotProps.data.uuid)
                                                    }, _toDisplayString(slotProps.data.name), 9, _hoisted_14)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(Column), {
                                                header: "Aktiv",
                                                sortable: true,
                                                sortField: "active"
                                            }, {
                                                body: _withCtx((slotProps) => [
                                                    _createVNode(YesNoIcon, {
                                                        answer: slotProps.data.active
                                                    }, null, 8, ["answer"])
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(Column), {
                                                header: "Letzte Änderung",
                                                sortable: true,
                                                sortField: "updatedAt"
                                            }, {
                                                body: _withCtx((slotProps) => [
                                                    _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(Column), {
                                                header: "Erstellt",
                                                sortable: true,
                                                sortField: "createdAt"
                                            }, {
                                                body: _withCtx((slotProps) => [
                                                    _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(Column), { header: "" }, {
                                                body: _withCtx((slotProps) => [
                                                    (slotProps.data.canRemove)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _createElementVNode("button", {
                                                                class: "btn",
                                                                onClick: ($event) => (removeDeliveryTypeCountry(slotProps.data.uuid))
                                                            }, [...(_cache[19] || (_cache[19] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        width: "16",
                                                                        height: "16",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-x-circle text-danger",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                                        _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                                    ], -1)
                                                                ]))], 8, _hoisted_16)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (!slotProps.data.canRemove)
                                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_17, [...(_cache[20] || (_cache[20] = [
                                                                _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }, null, -1),
                                                                _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" }, null, -1)
                                                            ]))]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 8, ["value", "filters"])
                                ])
                            ])
                        ]),
                        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "modal-header" }, [
                                            _createElementVNode("h1", {
                                                class: "modal-title fs-5 fw-bold",
                                                id: "createDeliveryTypeCountryModalLabel"
                                            }, "Neue Länderoption"),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn-close",
                                                "data-bs-dismiss": "modal",
                                                "aria-label": "Close"
                                            })
                                        ], -1)),
                                        _createElementVNode("form", {
                                            onSubmit: _withModifiers(createDeliveryTypeCountry, ["prevent"])
                                        }, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: "newDeliveryTypeCountryId",
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(createDeliveryTypeCountryForm).countryId) = $event))
                                                    }, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.countries, (country) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: country.id
                                                            }, _toDisplayString(country.name), 9, _hoisted_23));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(createDeliveryTypeCountryForm).countryId]
                                                    ]),
                                                    _cache[22] || (_cache[22] = _createElementVNode("label", { for: "newDeliveryTypeCountryId" }, "Land", -1))
                                                ])
                                            ]),
                                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "modal-footer" }, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-secondary",
                                                    "data-bs-dismiss": "modal"
                                                }, "Abbrechen"),
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    class: "btn btn-success d-inline-flex align-items-center"
                                                }, [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        width: "16",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                                    ]),
                                                    _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                                ])
                                            ], -1))
                                        ], 32)
                                    ])
                                ])
                            ])
                        ]))
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
